
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalStudentData from '@/components/templates/ModalStudentData.vue'
import { AvatarCode } from '@/const/AvatarCode'
import { UsersApi } from '@/api/methods/UsersApi'

/**
 * 生徒情報編集モーダル
 */
@Component({
  components: {
    ModalStudentData,
  },
})
export default class ModalEditStudentData extends Vue {
  /** 生徒情報編集モーダルのフォーマット */
  @Ref()
  modalStudentData!: ModalStudentData

  /** アイコン画像のリスト */
  private avatarList: AvatarCode.AvatarMaster[] = AvatarCode.LIST

  /** 生徒情報 */
  private student = this.$appCookies.authStudent.get()

  /**
   * 確認ボタン押下時の処理
   */
  private async submitEditedData(): Promise<void> {
    this.$loading.start()

    // 生徒情報更新
    await UsersApi.updateStudent(this.student.userId, this.modalStudentData.iconCode)

    // 最新生徒情報を取得
    const updatedStudent = await UsersApi.getStudentInformation(this.student.userId)

    // Cookie情報を更新
    this.$appCookies.authStudent.set(updatedStudent)

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()

    // Cookie再読み込みのため、自画面に遷移(VueRouterの警告回避のため、hrefを使用して強制的に遷移)
    window.location.href = this.$route.fullPath
  }

  /**
   * モーダルを開く
   */
  public async show(): Promise<void> {
    // 最新の生徒情報を取得する
    const studentInformation = await UsersApi.getStudentInformation(this.student.userId)

    this.modalStudentData.show(
      studentInformation.loginId,
      studentInformation.nickname,
      studentInformation.avatarIconCode
    )
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalStudentData.hide()
  }
}
